
import BlogPostsCarousel from '~/components/blog/BlogPostsCarousel.vue'
export default {
  name: 'BlogRelatedPosts',
  components: { BlogPostsCarousel },
  props: ['posts'],
}
